module.exports = __webpack_public_path__ + "static/media/C9.216fee46.jpg";